export default "__VITE_ASSET__Bx9rvzBy__"